<template>
  <div class="calc-results-plan d-flex flex-column align-items-center">
    <h2>Tirando seu CNPJ você precisará do serviço de contabilidade e nós temos o plano ideal para você.</h2>

    <div class="price">
      <label class="calc-results-plan__label">Mensalidades a partir de</label>

      <div class="value d-flex flex-row">
        <span class="value__prefix d-flex align-self-center">R$</span>
        <span class="value__number">{{ plan.price }}</span>
        <span class="value__suffix d-flex align-self-end">/ mês</span>
      </div>
    </div>

    <ButtomPrimary
    :disabled="false"
    :texto="'Confira nossos planos'"
    class="calc-results-plan__btn"
    :deepClass="'blue-normal'"
    :url="'https://www.contabilizei.com.br/quanto-custa-contabilizei/'"
    />

    <div class="mt20 ml10 mr10">
      <template v-for="(benefit, index) in plan.benefits">
        <p
          :key="index"
          class="benefit">
          <em class="mr10 material-icons">check</em>
          <span v-html="benefit" />
        </p>
      </template>
    </div>
  </div>
</template>

<script>

import ButtomPrimary from '@/components/ButtomPrimary'

export default {
  name: 'CalculatorResultsPlan',
  components: {
    ButtomPrimary
  },
  props: {
    plan: {
      type: Object,
      required: false,
      default: () => ({
        price: 189,
        benefits: [
          '<strong>Otimizamos os impostos</strong> do seu CNPJ para os seus honorários renderem',
          'Emita notas fiscais e acompanhe sua empresa <strong>24h por dia</strong> na nossa plataforma',
          'Escolha a forma de atendimento: <strong>WhatsApp, telefone, chat ou e-mail</strong>',
          '<strong>Planos com assessor especialista</strong> no seu segmento e que emite suas notas fiscais',
          'Contrate <strong>planos de saúde até 30% mais baratos</strong> do que os para pessoa física',
        ]
      }),
    },
  },
};
</script>

<style lang="scss" src="./CalculatorResultsPlan.styles.scss" scoped></style>

